import { render, staticRenderFns } from "./StorageNotification.vue?vue&type=template&id=5f056f3d&scoped=true"
import script from "./StorageNotification.vue?vue&type=script&lang=js"
export * from "./StorageNotification.vue?vue&type=script&lang=js"
import style0 from "./StorageNotification.vue?vue&type=style&index=0&id=5f056f3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f056f3d",
  null
  
)

export default component.exports